module.exports = __webpack_public_path__ + "static/media/de.13cdf733.svg";